import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter, Switch } from 'react-router-dom';
import ApplicationRoutes from './Routes/Routes';
import ChildRoute from './Routes/ChildRoute';
import { Provider } from 'react-redux';
import createStore from './store/Store'; 
import CustomPrompt from "./Common/Components/CustomPrompt";

const {  Routes } = ApplicationRoutes;

const getUserConfirmation = (message, callback) => {
    const modal = document.createElement('div')
    document.body.appendChild(modal)

    const withCleanup = (answer) => {
        ReactDOM.unmountComponentAtNode(modal)
        document.body.removeChild(modal)
        callback(answer)
    }

    ReactDOM.render(<CustomPrompt message={message} withCleanup={withCleanup} />, modal);
}

const Tarjetas = () => {
    return (
        <div>
            <Provider store={createStore()}>
                <HashRouter getUserConfirmation={getUserConfirmation}>
                    <div>
                            <Switch>
                                {Routes.map(route =>
                                    <ChildRoute
                                        exact={route.exact}
                                        path={route.path}
                                        component={route.component}
                                        isPrivate={route.isPrivate}
                                    />
                                )}
                            </Switch>
                    </div>
                </HashRouter>
            </Provider>
        </div>
    );
};

ReactDOM.render(<Tarjetas />, document.getElementById('Tarjetas'));
